import {AttachmentTypes} from "../../utils/constants";
import {useEffect, useState} from "react";
import HelperService from "../../services/helper-service";
import Attachment from "../files/attachment";
import GalleryWrapper from "./gallery-wrapper";

export default function Attachments({attachments, allowedTypes=[AttachmentTypes.document.val, AttachmentTypes.gallery.val],  ...props}) {
  const [galleryItems, setGalleryItems] = useState([]);
  const [documentItems, setDocumentItems] = useState([]);

  useEffect(()=>{
    if (attachments && attachments.length){

      if (allowedTypes.includes(AttachmentTypes.document.val)){
        let di = attachments.filter((item)=>{return item.attachment_type_id===AttachmentTypes.document.val;});
        setDocumentItems(di ? di : null);
      } else {
        setDocumentItems(null);
      }

      if (allowedTypes.includes(AttachmentTypes.gallery.val)){
        let gi = attachments.filter((item)=>{return item.attachment_type_id===AttachmentTypes.gallery.val;});
        setGalleryItems(gi ? gi : null);
      } else {
        setGalleryItems(null);
      }

    } else {
      setGalleryItems([]);
      setDocumentItems([]);
    }
  }, [attachments]);

  return (
    <>
        <div className={'row'}>
          {documentItems?.length>0 && <div className={'col'}>
            <h3>Na stiahnutie</h3>
            {documentItems.map((att)=>{
              return <Attachment key={att.id} attachment={att} controls={false} />;
            })}
          </div>}

          {galleryItems?.length>0 && <div className={'col'}>
            <h3>Galéria</h3>
            <GalleryWrapper>
            {galleryItems.map((att)=>{
              return <a key={att.id} href={att.url} className="d-inline-block m-2 mt-0 p-1 border rounded border-light shadow-sm" style={{maxWidth:'100%', maxHeight:'100%'}}>
                  <img src={att.thumbUrl} alt={att.title} style={{maxWidth:'100px', maxHeight:'100%', objectFit:'cover'}} />
                </a>;
            })}
            </GalleryWrapper>
          </div>}
        </div>
    </>
  );
}
